import styled from 'styled-components';
import { flexPosition, container, fontStyle } from '../../styles/mixins';
import {
  FONT_SIZE_7,
  INFO_COLOR,
  FONT_WEIGHT_BOLD,
  COL_SPACING,
  DANGER_COLOR,
} from '../../styles/variables';
import { Box } from '../../styles/customComponents';

export const ADDON_BOX_HEIGHT = '480px';

export const Container = styled.div`
  width: 100%;
  overflow-x: hidden;
  margin: 10px 0px 100px;
  position: relative;
`;

export const Content = styled.div`
  ${container()}
  text-align: ${({ emptySchedules }) => (emptySchedules ? 'center' : 'left')};
  .slick-list {
    /* overflow: hidden; */
    margin: 0;
    padding: 0 ${COL_SPACING / 2}px;
    margin: 0 -${COL_SPACING / 2}px;
  }
  .slick-prev {
  }
  .slick-next {
  }
  .slick-disabled {
    display: none !important;
    &:hover {
      transform: scale(1);
    }
  }
  .slick-track {
    position: relative;
    top: 0;
    left: 0;
    display: block;
    ${flexPosition({ align: 'center' })}
  }
  .slick-slide {
    float: left;
    height: 100%;
    margin-right: ${COL_SPACING}px;
    position: relative;
    
    &:not(.slick-active) {
      &::before {
        content: '';
        margin: 10px 0;
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        border-radius: 3px;
        background-color: rgba(255, 255, 255, 0.5);
        width: 100%;
        height: calc(100% - 20px);
      }
    }
    &.slick-cloned {
      opacity: 0;
    }
  }
`;

export const Item = styled.div``;

export const AddStep = styled.div`
  ${flexPosition({ align: 'center', justify: 'flex-start' })}
  p {
    ${fontStyle(INFO_COLOR, FONT_SIZE_7, FONT_WEIGHT_BOLD)}
    margin: 0;
    margin-left: 10px;
  }
`;

export const AddonBox = styled(Box)`
  height: ${ADDON_BOX_HEIGHT};
  ${({ center }) => (center ? flexPosition({ align: 'center', justify: 'center' }) : null)}
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 10px;
  border: ${({ error }) => (error ? `2px solid ${DANGER_COLOR}` : 'none')};
  border-radius: 5px;
`;

export const StepDataContainer = styled.div`
  margin-top: 20px;
  overflow-y: auto;
  width: 100%;
  padding: 0px 20px 20px;
  height: ${({ isVariationSelection }) => (isVariationSelection ? '100%' : '310px')};
`;



// WEBPACK FOOTER //
// ./src/components/ProductAddons/style.js